import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const CurriculumModuleCardSkeleton = () => {
  return (
    <div
      className='curriculum-module-card curriculum-module-card-skeleton'
      data-testid='curriculum-module-card-skeleton'
    >
      <div className='left-section'>
        <span className='module-number'>
          <Skeleton width={100} height={20} />
        </span>
        <span className='module-name font-s-lt'>
          <Skeleton width='100%' height={30} />
        </span>
      </div>
      <div className='right-section'>
        <div className='sub-modules-list'>
          <div className='sub-sub-modules-list'>
            {Array.from({ length: 4 }, (_, i) => (
              <div className='sub-sub-module-name' key={i}>
                <Skeleton height={20} width='70%' />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurriculumModuleCardSkeleton;
